export let AutoDraft = /*#__PURE__*/ function (AutoDraft) {
    AutoDraft[AutoDraft["None"] = 0] = "None";
    AutoDraft[AutoDraft["Save"] = 2] = "Save";
    AutoDraft[AutoDraft["Restore"] = 4] = "Restore";
    return AutoDraft;
}({});
